export const useDateDifferenceInSeconds = (
	startTime: string,
	endTime?: string
): number => {
	if (!endTime) {
		return 0;
	}

	try {
		const startDate = new Date(startTime);
		const endDate = new Date(endTime);

		if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
			console.error(
				"Передан неправильный формат даты в useDateDifferenceInSeconds"
			);
			return 0;
		}

		const differenceInMs = endDate.getTime() - startDate.getTime();
		const differenceInSeconds = Math.floor(differenceInMs / 1000);

		return differenceInSeconds;
	} catch (error) {
		console.error(
			"Ошибка при вычислении разности дат в useDateDifferenceInSeconds:",
			error
		);
		return 0;
	}
};
